// A pick from a choice card is sent as the message text, as a JSON object under one marker, so Andi reads it
// as the builder's direct answer to its question. The chat shows no bubble for it: the card showed the pick.
// "Something else" is not this: it's plain text, shown as a normal message.

const MARKER = '__elicitation__';

type ChoicePick = { action: 'accept'; value: string };

/** The message text that sends a pick. */
export const choiceMessage = (value: string): string => (
  JSON.stringify({ [MARKER]: { action: 'accept', value } satisfies ChoicePick })
);

/** The value picked, when a message is a pick. */
export function pickedValue(text: string): string | null {
  const trimmed = (text || '').trim();
  if (!trimmed.startsWith('{') || !trimmed.includes(MARKER)) return null;
  try {
    const value = (JSON.parse(trimmed) as Record<string, Partial<ChoicePick> | undefined>)[MARKER]?.value;
    return typeof value === 'string' ? value : null;
  } catch {
    return null;
  }
}

export const isChoiceMessage = (text: string) => pickedValue(text) !== null;

/** How a saved pick reads in the chat: the server records it as this event. */
export const clarifiedEvent = (value: string) => `Clarified with the user: "${value}"`;

const CLARIFIED = /^Clarified with the user: "(.*)"$/;

/** The pick a "Clarified" event records, rebuilt into the message that sent it. */
export function choiceMessageFromEvent(event: string): string | null {
  const value = CLARIFIED.exec(event)?.[1];
  return value === undefined ? null : choiceMessage(value);
}
